<template>
  <div class="branch_info">
    <div class="branch_text">
      <span class="branch-name">{{ branchInfo.name }}</span>
      <ul>
        <li v-if="branchInfo.leader">
          <span class="left-info">Руководитель: </span>
          <span class="right-info">{{
            branchInfo.leader.surname + ' ' + branchInfo.leader.name + ' ' + branchInfo.leader.patronymic
          }}</span>
        </li>
        <li>
          <span class="left-info">Кол-во студентов: </span>
          <span class="right-info">{{ branchInfo.users_count }}</span>
        </li>
        <li>
          <span class="left-info">Контакты: </span>
          <span class="right-info">{{ branchInfo.contact }}</span>
        </li>
        <li>
          <span class="left-info">Адрес: </span>
          <span class="right-info">{{ branchInfo.address }}</span>
        </li>
        <li>
          <span class="left-info">Дата создания: </span>
          <span class="right-info">{{ branchInfo.created_at | moment('DD.MM.YYYY') }}</span>
        </li>
      </ul>
    </div>
    <div class="branch-actions">
      <ul>
        <li v-if="userRole !== 'leader'">
          <button class="profile-edit" @click="$emit('edit', branchInfo)">
            <i class="mdi mdi-account-edit"></i> Редактировать филиал
          </button>
        </li>
        <li v-if="userRole !== 'leader'">
          <button class="profile-edit" @click="$emit('delete')">
            <i class="mdi mdi-account-remove-outline"></i> В архив
          </button>
        </li>
        <li v-if="userRole !== 'leader'">
          <button class="profile-edit" @click="$emit('commission-create')">
            <i class="mdi mdi-account-plus-outline"></i> Создать комиссию
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    branchInfo: {
      default: () => {},
      type: Object
    },
    coursesList: {
      default: () => [],
      type: Array
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
